import React, { useContext, useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Autocomplete, Box, Button, Grid, TextField, Typography } from '@mui/material';
import { ContextUserInfo } from '../MainPanel';
import { ContextNotification, severitys } from '../../../App';
import { RHFAutocomplete } from '../../../Components/RHFAutocomplete';
import helper from '../../../helper';
import BeatLoading from '../../../Components/Loader/BeatLoader';
import guestRequestApi from '../../../api/guestRequestApi';
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import CustomDateInput from '../../../Components/CustomDateInput';
import moment from 'jalali-moment'
import enumMapper from '../../../enumMapper';
import guestGroupApi from '../../../api/guestGroupApi';

const EditGuestGroupForm = ({ row, refreshGrid }) => {
  const { userInfo, userPermissions, userRoles } = useContext(ContextUserInfo);
  const { open, setOpen } = useContext(ContextNotification);
  const [submitLoading, setSubmitLoading] = useState(false);

  const schema = yup.object().shape({

  });
  const { register, setValue, handleSubmit, formState: { errors }, control, resetField, reset, getValues } = useForm({
    defaultValues: {
      startTrip: row.persian_StartTrip,
      endTrip: row.persian_EndTrip,
      description: row.description
      
    },
    resolver: yupResolver(schema),
  });

  function GetGregorianDate(input) {
    let dateGregorian = null;
    if (input) {
      let date = new DateObject({
        date: input,
        calendar: persian,
        locale: persian_fa
      });

      var dateStr = date.year + '/' + date.month.number + '/' + date.day;
      dateGregorian = moment.from(dateStr, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD')
    }
    return dateGregorian
  }

  const onSubmit = (data) => {
    setSubmitLoading(true);
      const newData = {
          "startTrip": GetGregorianDate(data.startTrip),
          "endTrip": GetGregorianDate(data.endTrip),
          "description": data.description
      }
    guestGroupApi.Update(row?.id, newData).then((res) => {
      if (res.data.success) {
        setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.success });
        resetForm();
        refreshGrid(true)
      }
      else {
        setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.error });
      }
    }).catch(err => {
      if (err.response && err.response.data && err.response.data.errors) {
        setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
      }
      else if (err.response && err.response.data) {
        setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
      }
      else if (err.message) {
        setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
      }
      else {
        setOpen({ IsEnable: true, Message: JSON.stringify(err), severity: severitys.error });
      }
    }
    ).finally(() => { setSubmitLoading(false); });
  };

  useEffect(() => {

  }, []);

  const resetForm = () => {
    resetField("");
  }
  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        {/* تاریخ‌ها */}
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Controller
              control={control}
              name="startTrip"
              rules={{ required: true }}
              render={({ field: { onChange, value } }) => (
                <DatePicker
                  value={value || null}
                  onChange={(date) => {
                    onChange(date?.isValid ? date : null);
                  }}
                  format="YYYY/MM/DD"
                  calendar={persian}
                  locale={persian_fa}
                  calendarPosition="bottom-right"
                  render={
                    <CustomDateInput
                      label="از"
                      error={!!errors?.startTrip}
                      helperText={errors?.startTrip?.message}
                    />
                  }
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <Controller
              control={control}
              name="endTrip"
              rules={{ required: true }}
              render={({ field: { onChange, value } }) => (
                <DatePicker
                  value={value || null}
                  onChange={(date) => {
                    onChange(date?.isValid ? date : null);
                  }}
                  format="YYYY/MM/DD"
                  calendar={persian}
                  locale={persian_fa}
                  calendarPosition="bottom-right"
                  render={
                    <CustomDateInput
                      label="تا"
                      error={!!errors?.endTrip}
                      helperText={errors?.endTrip?.message}
                    />
                  }
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
             <TextField
                      fullWidth
                      multiline
                      placeholder="توضیحات"
                      {...register(`description`)}
                      error={!!errors?.description}
                      helperText={errors?.description?.message}           
                    />
          </Grid>
        </Grid>

        <Box mt={3} display="flex" justifyContent="flex-start">
          <Button
            type="submit"
            variant="contained"
            disabled={submitLoading}
          >
            {submitLoading ? (
              <BeatLoading loading size={8} color="#fff" />
            ) : (
              "ثبت"
            )}
          </Button>
        </Box>
      </form>
    </div>
  )
}

export default EditGuestGroupForm